import { render, staticRenderFns } from "./editor-section.vue?vue&type=template&id=c70e0a38&"
import script from "./editor-section.vue?vue&type=script&lang=js&"
export * from "./editor-section.vue?vue&type=script&lang=js&"
import style0 from "./editor-section.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports